/**
 * UI-дескриптор модуля Меркурий для админки ядра (ARCH-TASK-65.12.7).
 */
import type { ModuleUiDescriptor } from '@core/modules/types'
import { MercurySection } from './MercurySection'

export { MercurySection }

/** Ключ meta принадлежит модулю, а не ядру. */
const META_MODULE_MERCURY_ENABLED = 'module_mercury_enabled'

export const mercuryModuleUi: ModuleUiDescriptor = {
  id: 'ru-mercury',
  title: 'ФГИС Меркурий',
  enabledMetaKey: META_MODULE_MERCURY_ENABLED,
  order: 20,
  applyEnabled: (enabled, core) => core.mercury.setEnabled(enabled),
  isEnabled: (core) => core.mercury.isEnabled(),
  Component: MercurySection
}
